import { render, staticRenderFns } from "./DatePickerView.vue?vue&type=template&id=8ffb6c84&scoped=true&"
import script from "./DatePickerView.vue?vue&type=script&lang=js&"
export * from "./DatePickerView.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerView.vue?vue&type=style&index=0&id=8ffb6c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffb6c84",
  null
  
)

export default component.exports